import { menuItems } from "../items";
import { usePrepareMenuItems } from "../utils/use-prepare-menu-items";

export function useNavigationItems() {
  return usePrepareMenuItems({
    items: menuItems,
  });
}
